var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWave1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    id: "svg",
    viewBox: "0 0 1440 390",
    xmlns: "http://www.w3.org/2000/svg",
    className: "transition duration-300 ease-in-out delay-150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0,400 L 0,400 C 120.32142857142858,278.75 240.64285714285717,157.5 364,145 C 487.35714285714283,132.5 613.7499999999999,228.75 738,216 C 862.2500000000001,203.25 984.3571428571429,81.5 1101,94 C 1217.642857142857,106.5 1328.8214285714284,253.25 1440,400 L 1440,400 L 0,400 Z",
    stroke: "none",
    strokeWidth: 0,
    fill: "#111111",
    fillOpacity: 1,
    className: "transition-all duration-300 ease-in-out delay-150 path-0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave1);
export default __webpack_public_path__ + "static/media/wave1.356f4319f6712d6333c7e71496e894b0.svg";
export { ForwardRef as ReactComponent };